// import React, { useState } from "react";
// import { Skeleton } from "../ui/skeleton";

// const Image = (props: React.ImgHTMLAttributes<HTMLImageElement>) => {
//   const [loading, setLoading] = useState(true);

//   if (!props.src) {
//     return <Skeleton className={props.className} />;
//   }
//   return (
//     <>
//       {loading && <Skeleton className={props.className} />}
//       <img
//         {...props}
//         onLoad={() => setLoading(false)}
//         className={`${loading ? "invisible" : "visible"} ${props.className}`}
//         onContextMenu={(e) => e.preventDefault()}
//         loading="lazy"
//       />
//     </>
//   );
// };

// export default Image;

import React, { useState } from "react";
import { Skeleton } from "../ui/skeleton";
import { cn } from "@/lib/utils";

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  imageclassName?: string;
}
const Image = (props: ImageProps) => {
  const [loading, setLoading] = useState(true);

  return (
    <div className={`relative ${props.className}`}>
      {loading && <img {...props} loading="eager" src="/noimage.png" />}
      <img
        {...props}
        loading="eager"
        src={props.src ?? "/noimage.png"}
        className={cn(
          loading ? "opacity-0" : "opacity-100",
          "transition-opacity",
          props.className,
          props.imageclassName
        )}
        onContextMenu={(e) => e.preventDefault()}
        onLoad={() => setLoading(false)}
        alt={props.alt ?? "Image"}
      />
    </div>
  );
};

export default Image;
